import { Card, Typography, Chip, Stack, Box } from "@mui/material";
import {
  typography,
  spacing,
  colors,
  shadows,
} from "../../../../../../../../../assets/styles/tokens";

interface EfficiencyMetricsCardsProps {
  title: string;
  value: string;
  total: string;
  rr: string;
  pr: string;
  rrColor?: "success" | "error" | "warning";
}

const buildShadow = (shadowToken: any) =>
  shadowToken.$value
    .map(
      (s: any) => `${s.offsetX} ${s.offsetY} ${s.blur} ${s.spread} ${s.color}`,
    )
    .join(", ");

export function EfficiencyMetricsCards({
  title,
  value,
  total,
  rr,
  pr,
  rrColor = "success",
}: EfficiencyMetricsCardsProps) {
  const rrStyles = {
    success: {
      bg: colors.Success[50].$value,
      color: colors.Success[600].$value,
    },
    warning: {
      bg: colors.Warning[50].$value,
      color: colors.Warning[600].$value,
    },
    error: {
      bg: colors.Error[50].$value,
      color: colors.Error[600].$value,
    },
  };

  return (
    <Card
      sx={{
        p: 1,
        flex: 1,
        borderRadius: 3,
        boxShadow: buildShadow(shadows.Shadows.sm),
      }}
    >
      {/* Top Row */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Typography
          variant="body2"
          sx={{
            color: colors.GrayLightMode[700].$value,
            fontWeight: typography.Font_weight.Medium.$value,
          }}
        >
          {title}
        </Typography>

        <Chip
          label={rr}
          size="small"
          sx={{
            bgcolor: rrStyles[rrColor].bg,
            color: rrStyles[rrColor].color,
            fontWeight: typography.Font_weight.Semibold.$value,
            borderRadius: spacing.Radius.sm.$value,
          }}
        />
      </Stack>

      {/* Main Metric */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: typography.Font_weight.Semibold.$value,
          color: colors.GrayLightMode[900].$value,
          mt: spacing.Spacing.xs.$value,
        }}
      >
        {value}
        <Box
          component="span"
          sx={{
            fontWeight: typography.Font_weight.Regular.$value,
            color: colors.GrayLightMode[600].$value,
            mx: spacing.Spacing.xxs.$value,
          }}
        >
          /
        </Box>
        <Box
          component="span"
          sx={{
            fontWeight: typography.Font_weight.Semibold.$value,
            color: colors.GrayLightMode[900].$value,
          }}
        >
          {total}
        </Box>
      </Typography>

      {/* PR Row */}
      <Typography
        variant="body2"
        sx={{
          color: colors.GrayLightMode[900].$value,
        }}
        mt={0.5}
      >
        PRR{" "}
        <Box
          component="span"
          sx={{
            color: colors.GrayLightMode[900].$value,
            fontWeight: typography.Font_weight.Semibold.$value,
          }}
        >
          {pr}
        </Box>
      </Typography>
    </Card>
  );
}
